// Il pop di un membro al lavoro: quello che il server ha dato al membro nel piano della sessione
// (`team_avatars`: due developer non hanno lo stesso pop), altrimenti quello del suo profilo.
import type { AgentProfile } from '../../lib/api';
import type { MissionTask } from '../../types';

export function faceOf(
  name: string,
  tasks: MissionTask[] | undefined,
  profiles: AgentProfile[] | null,
): string | null {
  const t = tasks?.find((x) => x.agent === name && x.avatar);
  if (t?.avatar) return t.avatar;
  const lower = name.toLowerCase();
  // il nome con cui scrive può essere il soprannome del pop («Teo»)
  const p = profiles?.find(
    (x) =>
      x.id === lower ||
      x.label.toLowerCase() === lower ||
      (x.nickname ?? '').toLowerCase() === lower,
  );
  return p?.avatar ?? null;
}

/** I membri del team di una sessione, una volta sola, con il loro pop. */
export function teamOf(tasks: MissionTask[] | undefined): { name: string; avatar: string }[] {
  const seen = new Map<string, string>();
  for (const t of tasks ?? []) if (t.avatar && !seen.has(t.agent)) seen.set(t.agent, t.avatar);
  return [...seen].map(([name, avatar]) => ({ name, avatar }));
}
